<template>
<div id="footer" class="">
  <div class="footer_info">
    <p><router-link to="/etc/privacy-policy" class="btn_pp">개인정보처리방침</router-link> / <router-link to="/etc/temrs-use" class="btn_pp">이용약관</router-link> / <router-link to="/etc/unauthorized-collection" class="btn_pp">이메일무단수집거부</router-link></p>
    <p>03924 서울특별시 마포구 월드컵북로 54길 11 (상암동 1599) 전자회관 11-12층</p>
    <p>대표번호 : <a href="tel:02-6388-6112">02-6388-6112</a> / 팩스번호 : 02-6388-6009</p>
    <p>Copyright © 2019 DAMDA. All Rights Reserved.</p>
  </div>
  <h2 class="footer_logo"><a href="#"><img src="/static/images/common/logoBottom_damda.png" alt="담다"></a></h2>
</div>
</template>

<script>
export default {
  name: 'main-footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/MainFooter.vue